import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import classNames from 'classnames';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import PeopleOutlinedIcon from '@material-ui/icons/PeopleOutlined';
import AppsOutlinedIcon from '@material-ui/icons/AppsOutlined';
import ManageCriteria from '@material-ui/icons/SettingsApplicationsOutlined';
import Invites from '@material-ui/icons/PersonAdd';
import logo from 'Images/logo_v1.svg';
import Menu from '@material-ui/icons/Menu';
import { IconButtonCustom } from '../../index';

const DrawerHeaderWrapper = styled.div`
  height: 120px;
  display: flex;
  padding: 0 8px;
  min-height: 56px;
  align-items: center;
  justify-content: space-evenly;
`;
const DrawerStyled = styled(Drawer)`
  & > div {
    background-color: #37464f;
    color: white;
    border-right: none;
  }
`;
const ListSpan = styled.span`
  margin-left: 20px;
  font-size: 26px;
`;
const ListIco = styled.div`
  margin-left: 5px;
`;
const VersionStyled = styled.div`
  margin: auto auto 10px 10px;
  font-size: 14px;
  color: #ffff;
`;

class Sidebar extends React.Component {
  state = {
    selectedIndex: 0,
  };

  handleListItemClick = (event, index) => {
    this.setState({ selectedIndex: index });
    this.props.trigerHandleListItemClick(index);
  };

  render() {
    const sidebarItems = [
      {
        text: 'Home',
        icon: <HomeOutlinedIcon />,
        index: 0,
      },
      {
        text: 'Demand users',
        icon: <PeopleOutlinedIcon />,
        index: 1,
      },
      {
        text: 'Company users',
        icon: <AppsOutlinedIcon />,
        index: 2,
      },
      // {
      //   text: 'Invites',
      //   icon: <Invites />,
      //   index: 3,
      // },
      {
        text: 'Manage criteria',
        icon: <ManageCriteria />,
        index: 4,
      },
    ];

    const { classes, theme, open } = this.props;
    return (
      <DrawerStyled
        variant="permanent"
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
        open={open}
      >
        <DrawerHeaderWrapper>
          <img src={logo} alt="" />
          <IconButtonCustom
            open={!open}
            onClick={this.props.handleDrawerClose}
            isWhite={true}
          >
            <Menu />
          </IconButtonCustom>
        </DrawerHeaderWrapper>
        <Divider />
        <List component="nav">
          {sidebarItems.map(sidebarItem => (
            <ListItem
              button
              key={sidebarItem.text}
              selected={this.state.selectedIndex === sidebarItem.index}
              onClick={event => {
                this.handleListItemClick(event, sidebarItem.index);
              }}
            >
              <ListIco>{sidebarItem.icon}</ListIco>
              <ListSpan>{sidebarItem.text}</ListSpan>
            </ListItem>
          ))}
        </List>
        <VersionStyled>v1.4.08</VersionStyled>
      </DrawerStyled>
    );
  }
}

export default Sidebar;
